// extracted by mini-css-extract-plugin
export default {"dataTable":"ReceiverGroupAnalyticsTable_dataTable__IZOY8"};